import { render } from "./SelectIngredientModal5.vue?vue&type=template&id=6c70f031"
import script from "./SelectIngredientModal5.vue?vue&type=script&lang=js"
export * from "./SelectIngredientModal5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__